import { render, staticRenderFns } from "./Template240.vue?vue&type=template&id=25536118"
import script from "./Template240.vue?vue&type=script&lang=js"
export * from "./Template240.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25536118')) {
      api.createRecord('25536118', component.options)
    } else {
      api.reload('25536118', component.options)
    }
    module.hot.accept("./Template240.vue?vue&type=template&id=25536118", function () {
      api.rerender('25536118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Template240.vue"
export default component.exports